/**
 * 音声入力の確定テキストを既存入力へ連結するときの区切り文字を決める。
 *
 * 日本語では単語間に空白を入れない慣習に合わせて区切りを付けず、それ以外の言語では
 * 既存テキスト末尾と次テキスト先頭のどちらにも空白が無いときだけ半角スペースを補う。
 * 確定テキストの追記（provider）と仮テキストのオーバーレイ表示（間隔合わせ）で同じ規則を
 * 使うため共通化している。
 */
export function getSpeechSeparator(
  previous: string,
  next: string,
  locale: string,
): string {
  if (previous.length === 0 || next.length === 0) {
    return "";
  }
  if (locale.startsWith("ja")) {
    return "";
  }
  if (/\s$/.test(previous) || /^\s/.test(next)) {
    return "";
  }
  return " ";
}
